import {Routes} from "@angular/router";
import {MainLayoutComponent} from "./main-layout/main-layout.component";
import {LoginPageComponent} from "./login-page/login-page.component";
import {DashboardPageComponent} from "./dashboard-page/dashboard-page.component";
import {authGuard} from "./core/guard/auth.guard";
import {ProjectListingComponent} from "./dashboard-page/components/project-listing/project-listing.component";
import {ProductListingComponent} from "./dashboard-page/components/product-listing/product-listing.component";
import {UserListingComponent} from "./dashboard-page/components/user-listing/user-listing.component";
import {OfferListingComponent} from "./dashboard-page/components/offer-listing/offer-listing.component";
import {ProductHandlingComponent} from "./dashboard-page/components/product-handling/product-handling.component";
import {productEditHandlingGuard} from "./core/guard/product-edit-handling.guard";
import {productCloneHandlingGuard} from "./core/guard/product-clone-handling.guard";
import {employeeGuard} from "./core/guard/employee.guard";
import {localeGuard} from "./core/guard/locale.guard";
import {UserHandlingComponent} from "./dashboard-page/components/user-handling/user-handling.component";
import {userHandlingGuard} from "./core/guard/user-handling.guard";
import {RegistrationPageComponent} from "./registration-page/registration-page.component";
import {logoutGuard} from "./core/guard/logout-guard";

export const appRoutes: Routes = [

        {
                path: '',
                component: MainLayoutComponent,
                canActivate: [localeGuard]
        },
        {
                path: 'login',
                component: LoginPageComponent,
                canActivate: [localeGuard, logoutGuard]
        },
        {
                path: 'register',
                component: RegistrationPageComponent,
                canActivate: [localeGuard, logoutGuard],
                data: { action: 'register' }
        },
        {
                path: 'dashboard',
                component: DashboardPageComponent,
                canMatch: [authGuard, localeGuard],
                children: [
                        {
                                path: 'projects',
                                component: ProjectListingComponent
                        },
                        {
                                path: 'users',
                                component: UserListingComponent,
                                canMatch: [employeeGuard],
                                children: [
                                        {
                                                path: 'new',
                                                component: UserHandlingComponent,
                                                data: { action: 'create' }
                                        },
                                        {
                                                path: 'edit/:id',
                                                component: UserHandlingComponent,
                                                data: { action: 'edit' },
                                                canActivate: [userHandlingGuard]
                                        },
                                        {
                                                path: '**',
                                                redirectTo: '',
                                                pathMatch: 'prefix'
                                        }
                                ]
                        },
                        {
                                path: 'offers',
                                component: OfferListingComponent,
                                canMatch: [employeeGuard]
                        },
                        {
                                path: 'products',
                                component: ProductListingComponent,
                                canMatch: [employeeGuard],
                                children: [
                                        {
                                                path: 'new',
                                                component: ProductHandlingComponent,
                                                canActivate: [ productCloneHandlingGuard ]
                                        },
                                        {
                                                path: 'edit/:id',
                                                component: ProductHandlingComponent,
                                                canActivate: [ productEditHandlingGuard ]
                                        },
                                        {
                                                path: 'clone/:id',
                                                redirectTo: 'new',
                                        },
                                        {
                                                path: '**',
                                                redirectTo: '',
                                                pathMatch: 'prefix'
                                        }
                                ]
                        },
                        {
                                path: '**',
                                redirectTo: 'projects',
                                pathMatch: 'prefix'
                        },
                ]


        },
        {
                path: '**',
                redirectTo: '',
                pathMatch: 'full', canMatch: [localeGuard]},
        //...otherRoutes from another route file
];
